// vendor import
import { FontawesomeProvider } from './fontawesome';
import { Md5Provider } from './md5';
import { MomentProvider } from './moment';
import { MoneyProvider } from './money';
import { UuidProvider } from './uuid';

export const vendor: any[] = [
  // vendor export
  FontawesomeProvider,
  Md5Provider,
  MomentProvider,
  MoneyProvider,
  UuidProvider,
];
